import * as React from "react";

interface ErrorPageProps {}

const ErrorPage: React.FC<ErrorPageProps> = () => {
    return <div>Error Page</div>;
};

export default ErrorPage;
